import Vue from 'vue';

export default Vue.component('save-alert', {
  template: require('./template.html'),
  computed: {
    checkSaved() {
      return this.$store.getters.activeAction;
    },
  },
  name: 'save-alert',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/save-alert/index.js